import { jsx as _jsx } from "react/jsx-runtime";
import { Link, Typography } from "./Breadcrumb.components.js";
export const BreadcrumbAtomComponent = ({ label, path, ...props }) => path?.trim() ? (_jsx(Link, { "data-testid": "BreadcrumbLink", underline: "hover", color: "primary", href: path, ...props, children: label })) : (_jsx(Typography, { "data-testid": "BreadcrumbText", ...props, children: label }));
export default BreadcrumbAtomComponent;
